var thumbsSwiper = new Swiper(".oil-featured-pdp-section .product-thumbs", {
    direction: "vertical",
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
});

var mainSwiper = new Swiper(".oil-featured-pdp-section .product-main", {
    spaceBetween: 10,
    navigation: {
        nextEl: ".oil-swiper-button-next",
        prevEl: ".oil-swiper-button-prev",
    },
    pagination: {
        el: '.oil-swiper-pagination',
        clickable: true,
        dynamicBullets: true
    },
    thumbs: {
        swiper: thumbsSwiper,
    },
     breakpoints: {
         768:{
            slidesPerView: 1,
        },
        10:{
            slidesPerView: 'auto',
        }
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".accordion-item");
    items.forEach((item) => {
        const header = item.querySelector(".accordion-header");
        header.addEventListener("click", () => {
            const isOpen = item.classList.contains("active");
            items.forEach(i => {
                i.classList.remove("active");
                i.querySelector(".accordion-content").style.maxHeight = null;
            });
            if (!isOpen) {
                item.classList.add("active");
                const content = item.querySelector(".accordion-content");
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});